<script lang="ts">
  import { onMount } from "svelte"
  import { Layout } from "../../components"
  import { Code } from "@gl/design-system"
  import { getCopyjob } from "../../services/endpoints"
  
  export let uuid;
  
  let copyJob: null | string = null;
  
  onMount(() => {
    getCopyjob(uuid).then((cj) => copyJob = JSON.stringify(cj, null, 2))
  })
</script>

<Layout selected="copyjobs">
  {#if copyJob}
  <Code>
    {copyJob}
  </Code>
  {/if}
</Layout>